import { render, staticRenderFns } from "./NavigationTabs.vue?vue&type=template&id=0047c8a5&"
import script from "./NavigationTabs.vue?vue&type=script&lang=js&"
export * from "./NavigationTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports